import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { getFilteredFacetValues } from "./getFilteredFacetValues";
import SearchBox from "./SearchBox";
import isFilterableFacet from "./isFilterableFacet";
import getOnChangeHandler from "./getOnChangeHandler";
import getOnClearHandler from "./getOnClearHandler";
import { updateSearchTerm } from "../../state/modules/facet";

function withTextFilter(WrappedComponent) {
  function WithTextFilter({ facet, ...rest }) {
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");

    const onChange = useCallback(params => dispatch(updateSearchTerm(params)), [
      dispatch
    ]);

    const isFiltered = () => !!searchTerm.length;

    useEffect(() => () => dispatch(updateSearchTerm({ searchTerm: "" })), [
      dispatch
    ]);

    if (facet === undefined) return null;

    const onChangeHandler = getOnChangeHandler({ onChange, setSearchTerm });
    const onClearHandler = getOnClearHandler({ onChange, setSearchTerm });

    const searchBox = isFilterableFacet({ facet }) ? (
      <SearchBox
        searchTerm={searchTerm}
        onChange={onChangeHandler}
        onClear={onClearHandler}
      ></SearchBox>
    ) : null;

    return (
      <WrappedComponent
        facet={facet}
        searchBox={searchBox}
        isFiltered={isFiltered()}
        clearSearchBox={() => setSearchTerm("")}
        filteredFacetValues={getFilteredFacetValues({
          facetValues: facet.facetValues,
          searchTerm
        })}
        {...rest}
      />
    );
  }

  WithTextFilter.propTypes = {
    facet: PropTypes.shape({
      facetValues: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      ).isRequired
    })
  };

  return WithTextFilter;
}

export default withTextFilter;
